// extracted by mini-css-extract-plugin
module.exports = {"mobileTable":"mobileTable--2Ju_m","fullSizeTable":"fullSizeTable--2XOav"};